import { Component } from 'react';

const isChunkError = (error) => /Loading chunk|ChunkLoadError|Failed to fetch dynamically imported module/i.test(String(error?.message || error));
const reloadKey = 'glc-chunk-reload-attempted';

export class AppErrorBoundary extends Component {
  state = { error: null };

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error) {
    const lastAttempt = Number(sessionStorage.getItem(reloadKey));
    if (!isChunkError(error) || (lastAttempt && Date.now() - lastAttempt < 300000)) return;
    sessionStorage.setItem(reloadKey, String(Date.now()));
    window.location.reload();
  }

  render() {
    if (!this.state.error) return this.props.children;
    return <main className="flex min-h-screen items-center justify-center bg-slate-950 px-6 text-center text-white"><div className="max-w-md"><h1 className="text-3xl font-bold">We could not load this page</h1><p className="mt-4 text-slate-300">Please refresh the page. If the problem continues, call us on 068 680 1986.</p><button type="button" onClick={() => window.location.reload()} className="mt-7 rounded-full bg-emerald-500 px-6 py-3 font-semibold text-slate-950 hover:bg-emerald-400">Refresh page</button></div></main>;
  }
}
